import {combineReducers} from '@reduxjs/toolkit'
import loginReducer from './login/login.reducer'
import campaignsReducer from './campaigns/campaigns.reducer'
import mediaReducer from './media/media.reducer';
import referenceReducer from './referenceSlice';

const rootReducers = combineReducers({
    login: loginReducer,
    campaigns: campaignsReducer,
    media: mediaReducer,
    reference : referenceReducer
})

export default rootReducers